import {GlobalNavMenuPartial} from '@github-ui/global-navigation/menu'
import {registerReactPartial} from '@github-ui/react-core/register-partial'

registerReactPartial('global-nav-menu', {
  Component: GlobalNavMenuPartial,
})
